module.exports = __webpack_public_path__ + "static/RST-PIO-CAN-3-424d3abff554aa144a6b67bef2ba3401.jpg";